import React, { useEffect, useMemo, useRef, useState } from "react";
import { Loader1 } from "../../../core/assets";
import { Cons, Release } from "../../../core/assets";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import { AnimatePresence, motion } from "framer-motion";
import { Collab9, Collab10, Collab11 } from "../../../core/assets";

export const GridInfo = () => {
  const animateText = useMemo(() => [
    { text: Collab9 },
    { text: Collab10 },
    { text: Collab11 },
  ], []);
  const [slideText] = useState(animateText);
  const [activeTextIndex, setActiveTextIndex] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setActiveTextIndex((prevIndex) => (prevIndex + 1) % animateText.length);
    }, 8000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [activeTextIndex, animateText]);

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const handleVideoPlay = () => {
      if (videoRef.current) {
        videoRef.current.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    };

    // Attach the play event listener to a user interaction event (e.g., click)
    window.addEventListener("click", handleVideoPlay);

    return () => {
      window.removeEventListener("click", handleVideoPlay);
    };
  }, []);
  
  return (
    <section className="h-auto ">
      <Fade bottom>
        <section className=" bg-stone-100  mt-12 rounded-2xl mx-5 md:mx-0">
          <div className="grid lg:grid-cols-3 gap-5  md:p-12 p-0   ">
            <div className="text-4xl p-8 md:p-0  ">New Releases</div>
            <div className="w-full lg:w-[300px] md:w-full px-8 md:px-0 text-gray-500 ">
              The iconic shoe soon became the go-to choice of sports stars,
              artists and musicians alike, and to this day is a part of the
              uniform of daily life. The All Star still remains Converse’s key
              style, while apparel and accessories collections now sit alongside
              its sneakers to offer a full lifestyle range
            </div>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTextIndex}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                className="text-black text-5xl  mt-[-5%]  font-light flex justify-center"
              >
                <img
                  src={slideText[activeTextIndex].text}
                  alt="new"
                  className="w-[300px] h-[300px]"
                />
              </motion.div>
            </AnimatePresence>
          </div>
        </section>
      </Fade>

      <section className="mt-6 h-auto">
        <div className="grid lg:grid-cols-1 xl:grid-cols-2 gap-5 align-content ">
          {/* {show on smaller page screen} */}
          <div className="second-col lg:w-[100%] h-[400px] px-5 rounded-xl block md:hidden">
          <video
                  ref={videoRef}
                  src={Loader1}
                  style={{ width: "100%", height: "", objectFit: "cover" }}
                  className="rounded-2xl h-full"
                  playsInline
                  autoPlay
                  muted
                  loop
                />
          </div>

          <div className="first-col rounded-2xl pb-20 md:mx-0 mx-5 mb-5 md:mb-0 bg-transparent 0 p-4 md:h-[auto] xl:h-[auto]  ">
            <div>
              <Zoom clear>
                <img
                  src={Cons}
                  alt="logo"
                  className=" flex justify-end md:w-[100px] object-contain w-[150px] filter invert"
                />
              </Zoom>
            </div>

            <div className=" text-black   bottom-0 left-0 right-0">
              <div className="rounded-xl">
                <Fade bottom>
                  <img
                    className="w-full md:h-[550px] h-full object-cover  rounded-xl"
                    src={Release}
                    alt="sneaker"
                    style={{ borderRadius:"10px !important" }}
                  />
                </Fade>
              </div>

              <Fade top cascade>
                <div className="px-0 md:px-12 lg:px-8  py-5 md:py-3">
                  <p className="text-xl md:text-2xl mb-4 font-extrabold px-5 md:px-0 w-full md:w-[70%] lg:w-[90%]">
                    A Closer Look At The A-COLD-WALL x Converse Geo Forma Boot
                    in Black
                  </p>
                  <p className="w-full  lg:w-[90%] px-5 md:px-0 text-neutral-400 ">
                    Samuel Ross<b> ’ A-COLD-WALL* </b>and Converse have teamed
                    up to unleash the awe-inspiring Geo Forma boot, and this is
                    not your average Chuck Taylor All-Star! Take a closer look
                    at the
                    <b> A-COLD-WALL</b> x Converse Geo Forma Boot in black and
                    get to know all the deets you need before the cop!
                  </p>
                </div>
              </Fade>
            </div>
          </div>

          <Fade right>
            {/* {show on medium and large page screen} */}
            <div className="second-col w-full h-full  bg-transparent md:block hidden">
              <video
                src={Loader1}
                autoPlay
                muted
                loop
                style={{ objectFit: "cover" }}
                className=" md:rounded-2xl h-full w-full"
              />
            </div>
          </Fade>
        </div>
      </section>
    </section>
  );
};
